// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-combo';

export const Component = () => (
  <path d='M0 0h1v21h21v1H0V0Zm18.5 8v11H15V8h3.5Zm-6 3v8H9v-8h3.5Zm-6 3v5H3v-5h3.5ZM16.75 3a1.75 1.75 0 1 1-1.276 2.947l-3 1.499a1.75 1.75 0 0 1-3 1.502l-3 1.498a1.75 1.75 0 1 1-.448-.893l3-1.499a1.75 1.75 0 0 1 3-1.502l3-1.498A1.75 1.75 0 0 1 16.75 3Zm-12 7a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm6-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm6-3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z' />
);

export const viewBox = '0 0 22 22';
